import { put, select, takeEvery } from "redux-saga/effects";
import { actions, selectors } from "redux-store";

export function* devicesSubscribedAndReachedStatsSaga() {
  yield takeEvery(actions.triggerDevicesSubscribedAndReachedRequest, function* (
    action,
  ) {
    const filters = yield select(selectors.getStatsFilters);

    yield put(
      actions.getStatsMerchantsEventsDevicesByMerchantId.request({
        merchantId: action.payload.merchantId,
        filters,
      }),
    );
  });
}
